import React, { FC, useCallback } from 'react';

import { Icon } from '@rbilabs/components-library/build/components/icon';
import { useIntl } from 'react-intl';

import { ActionButton, ActionButtonVariants } from 'components/action-button';

import { VIEW_ICON_MAP, VIEW_MESSAGE_ID_MAP } from './constants';
import { IToggleViewButtonProps, StoreLocatorViews } from './types';

export const ToggleViewButton: FC<IToggleViewButtonProps> = ({
  variant,
  color,
  className,
  currentView,
  updateStoreLocatorView,
}) => {
  const { formatMessage } = useIntl();

  const handleToggleLocatorViewClick = useCallback(() => {
    const newView =
      currentView === StoreLocatorViews.LIST_VIEW
        ? StoreLocatorViews.MAP_VIEW
        : StoreLocatorViews.LIST_VIEW;
    updateStoreLocatorView(newView);
  }, [currentView, updateStoreLocatorView]);

  // display map option when they are on the list view
  return (
    <ActionButton
      aria-label={`${formatMessage({ id: 'switchTo' })} ${formatMessage({ id: VIEW_MESSAGE_ID_MAP[currentView] })}`}
      variant={variant ?? ActionButtonVariants.PRIMARY}
      color={color ?? 'text-button-reversed'}
      endIcon={<Icon icon={VIEW_ICON_MAP[currentView]} color="primary" aria-hidden />}
      className={className}
      onClick={handleToggleLocatorViewClick}
      data-testid="toggle-view-button"
      skipLogEvent
      onlyIcon
    >
      {formatMessage({ id: VIEW_MESSAGE_ID_MAP[currentView] })}
    </ActionButton>
  );
};
